module.exports = __webpack_public_path__ + "img/capsule-1@2x.06f942cf.webp";